// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__oglSc","title":"styles_title__oEya4","right":"styles_right__rgdEo","menuArea":"styles_menuArea__lxFnW"};